





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component
export default class InsNews extends Vue {
    newsData: object = {};

    getNewsData () {
      this.$Api.cms.getCategoryByDevice({ CatId: 50130, IsMobile: this.isMobile }).then((result) => {
        this.newsData = result;
      });
    }

    get isMobile () {
      return this.$store.state.isMobile;
    }

    get lang () {
      return this.$Storage.get('locale');
    }

    mounted () {
      this.getNewsData();
    }

  @Watch('isMobile', { deep: true })
    onMediaChange () {
      this.getNewsData();
    }
}
